<template>
  <!-- Overlay -->
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <!-- Contenu du popup -->
    <div class="bg-white rounded-11 shadow-lg w-full max-w-xl p-6">
      <!-- Bouton fermer -->
      <div class="flex items-center justify-between gap-4 pb-4 border-b border-gray-500">
        <div class="text-c18 font-c7">
          Description du besoin
        </div>
        <button
          class="text-gray-500 hover:text-gray-700 "
          @click="$emit('close')"
        >
          ✕
        </button>
      </div>
      <!-- Contenu -->
      <div
        v-if="oneRequest.company"
        class="pt-4"
      >
        <p class="mb-2 text-left bgyellow p-2 rounded-10 flex gap-3 font-c7">
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.4587 2.08398H10.542C11.292 2.08398 11.917 2.08398 12.4087 2.15065C12.9337 2.21732 13.4003 2.37565 13.7837 2.75898C14.167 3.13398 14.317 3.60898 14.392 4.13398C14.442 4.49232 14.4503 4.92565 14.4587 5.42565C14.967 5.43398 15.4087 5.45065 15.8003 5.49232C16.542 5.56732 17.1587 5.72565 17.7003 6.08398C18.1337 6.37565 18.5003 6.74232 18.792 7.17565C19.1503 7.71732 19.3087 8.33398 19.3837 9.07565C19.4587 9.79232 19.4587 10.7007 19.4587 11.8423V11.909C19.4587 13.0507 19.4587 13.959 19.3837 14.6757C19.3087 15.4173 19.1503 16.034 18.792 16.5757C18.5003 17.009 18.1337 17.3757 17.7003 17.6673C17.1587 18.0257 16.542 18.184 15.8003 18.259C15.0753 18.334 14.1753 18.334 13.0337 18.334H7.96699C6.82533 18.334 5.92533 18.334 5.20033 18.259C4.45866 18.184 3.84199 18.0257 3.30033 17.6673C2.86699 17.3757 2.50033 17.009 2.20866 16.5757C1.85033 16.034 1.69199 15.4173 1.61699 14.6757C1.54199 13.959 1.54199 13.0507 1.54199 11.909V11.8423C1.54199 10.7007 1.54199 9.79232 1.61699 9.07565C1.69199 8.33398 1.85033 7.71732 2.20866 7.17565C2.50033 6.74232 2.86699 6.37565 3.30033 6.08398C3.84199 5.72565 4.45866 5.56732 5.20033 5.49232C5.59199 5.45065 6.03366 5.43398 6.54199 5.42565C6.54199 4.92565 6.55866 4.49232 6.60866 4.13398C6.67533 3.60898 6.83366 3.13398 7.21699 2.75898C7.60033 2.37565 8.06699 2.21732 8.59199 2.15065C9.08366 2.08398 9.70866 2.08398 10.4587 2.08398ZM13.1503 4.30065C13.192 4.58398 13.2003 4.94232 13.2003 5.41732H7.78366C7.78366 4.94232 7.80033 4.58398 7.83366 4.30065C7.88366 3.90898 7.97533 3.75065 8.08366 3.64232C8.19199 3.53398 8.35866 3.44232 8.74199 3.39232C9.14199 3.33398 9.68366 3.33398 10.4837 3.33398C11.2837 3.33398 11.8253 3.33398 12.2253 3.39232C12.6087 3.44232 12.7753 3.53398 12.8837 3.64232C12.992 3.75065 13.0837 3.90898 13.1337 4.30065H13.1503ZM5.32533 6.73398C4.68366 6.80065 4.30033 6.92565 3.99199 7.12565C3.70033 7.31732 3.44199 7.57565 3.24199 7.86732C3.04199 8.17565 2.91699 8.55898 2.85033 9.20065C2.78366 9.85065 2.78366 10.6923 2.78366 11.8757C2.78366 13.059 2.78366 13.9007 2.85033 14.5506C2.91699 15.1923 3.04199 15.5757 3.24199 15.884C3.44199 16.1757 3.69199 16.434 3.99199 16.6257C4.29199 16.8257 4.68366 16.9507 5.32533 17.0173C5.97533 17.084 6.81699 17.084 8.00033 17.084H13.0003C14.1837 17.084 15.0253 17.084 15.6753 17.0173C16.317 16.9507 16.7003 16.8257 17.0087 16.6257C17.3003 16.434 17.5587 16.1757 17.7587 15.884C17.9587 15.5757 18.0837 15.1923 18.1503 14.5506C18.217 13.9007 18.217 13.059 18.217 11.8757C18.217 10.6923 18.217 9.85065 18.1503 9.20065C18.0837 8.55898 17.9587 8.17565 17.7587 7.86732C17.5587 7.57565 17.3087 7.31732 17.0087 7.12565C16.7087 6.92565 16.317 6.80065 15.6753 6.73398C15.0253 6.66732 14.1837 6.66732 13.0003 6.66732H8.00033C6.81699 6.66732 5.97533 6.66732 5.32533 6.73398ZM5.68366 8.77565C5.60487 8.75125 5.52204 8.74268 5.43992 8.75044C5.35781 8.7582 5.27805 8.78214 5.20523 8.82087C5.13241 8.85961 5.06798 8.91237 5.01565 8.97612C4.96332 9.03987 4.92413 9.11335 4.90033 9.19232C4.80033 9.51732 4.98366 9.86732 5.30866 9.97565L5.85033 10.1423C7.14199 10.5423 8.50033 10.7673 9.86699 10.8257V11.8757C9.86699 12.2173 10.1503 12.5007 10.492 12.5007C10.8337 12.5007 11.117 12.2173 11.117 11.8757V10.8257C12.4837 10.7673 13.842 10.5423 15.1337 10.1423L15.6753 9.97565C16.0087 9.86732 16.192 9.51732 16.0837 9.19232C16.0599 9.11335 16.0207 9.03987 15.9683 8.97612C15.916 8.91237 15.8516 8.85961 15.7788 8.82087C15.7059 8.78214 15.6262 8.7582 15.5441 8.75044C15.4619 8.74268 15.3791 8.75125 15.3003 8.77565L14.7587 8.95065C11.9738 9.7931 9.0019 9.7931 6.21699 8.95065L5.67533 8.77565H5.68366Z"
              fill="#FDA300"
            />
          </svg>

          {{ oneRequest.request.serviceChoice.title }}
        </p>
        <!--  -->
        <p class="mb-2 text-left font-c7 text-c16 mt-7 textat">
          <strong>
            Description du service: <br>
          </strong>
        </p><div class="textat text-left font-6">
          {{ oneRequest.request.description }}
        </div>
        <p class="mb-2 text-left font-c7 text-c16 mt-5 ">
          <strong>
            Description: <br>
          </strong>
        </p>
        <div class="textat text-left font-6">
          {{ oneRequest.request.activityDescription }}
        </div>
      </div>

      <!-- Bouton action -->
      <div class="mt-7 flex justify-end">
        <button
          class="treter text-white px-4 py-2 rounded-8"
          @click="$emit('updateState')"
        >
          Marquer comme traité
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupBaseVue",
  props: {
oneRequest: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["close", "updateState"],
};
</script>

<style>
.bgyellow{
    background-color: #F7DCBC70;
}
.treter{
    background-color: #241A72;
}
.textat{
    color: #303030;
}
</style>